// TODO: Internationalize once subscriptions are not CZ-only
export const membershipTaxRate = 21;
